module.exports = __webpack_public_path__ + "1456132833b18b6179d02aad81861fd6.svg";